import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prompt-content__tips" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "prompt-content__tips--text" }, /*#__PURE__*/_toDisplayString('你切换过账号，正在使用'), -1)
const _hoisted_3 = { class: "account-info" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "account-info__nickname--suffix" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "prompt-content__tips--text" }, " 访问空间 ", -1)
const _hoisted_7 = { class: "prompt-content__button" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 继续访问 ")

import { NAvatar, NButton } from 'naive-ui'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
import ChangeAccountBtn from '@teams/common/components/changeAccountBtn'

import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  __name: 'loginPublicMember',
  setup(__props) {

const { onContinueVisit, currentAccountInfo } = useAccountChange()
const { t } = useI18n()
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.forbiddenJoin.${key}`, ...params)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(NAvatar), {
          round: "",
          size: 24,
          src: _unref(currentAccountInfo)?.pic
        }, null, 8, ["src"]),
        _createElementVNode("span", {
          class: "account-info__nickname",
          title: _unref(currentAccountInfo)?.nickname
        }, _toDisplayString(_unref(currentAccountInfo)?.nickname), 9, _hoisted_4),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currentAccountInfo)?.is_company_account ? '(企业账号)' : '(个人账号)'), 1)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(ChangeAccountBtn), {
        btnText: $tt('okText'),
        isShowRectangle: false,
        scrollbarStyle: {
        maxHeight: '280px',
        marginTop: '4px'
      },
        type: "default",
        itemStyle: { margin: '2px 4px' },
        popoverStyle: { width: '296px' }
      }, null, 8, ["btnText"]),
      _createVNode(_unref(NButton), {
        type: "primary",
        onClick: _unref(onContinueVisit),
        class: "prompt-content__button--default"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}
}

})